(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.image_marker = {
    attach: function (context, settings) {
      // image marker

      // Check if any item $('.field--name-field-image-marker area') has a class "active"
      // If no item has active then we take first item and add active to the area but also to .field--name-field-image-marker node__content marker-body
      if (!$('.field--name-field-image-marker area.active').length) {
        $('.field--name-field-image-marker area').first().addClass('active');
        $('.field--name-field-image-marker .marker-body').first().addClass('active');
      }

      $('.field--name-field-image-marker area').on('click', function () {
        $('.field--name-field-image-marker area').removeClass('active');
        $('.field--name-field-image-marker .marker-body').removeClass('active');
        $(this).addClass('active');
        $('.field--name-field-image-marker .marker-body[data-group-id="' + $(this).attr('group') + '"]').addClass('active');
      });
    }
  };

})(jQuery, Drupal);